import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  AllGroupNotificationsResponse,
  getAllGroupNotificationApi,
  getGroupNotificationApi,
  GroupNotificationResponse,
  NotificationGroupRequest,
  updateGroupNotificationApi,
} from "./api";
import { State } from "@features/base/types";

export const getAllGroupNotification = createAsyncThunk<
  AllGroupNotificationsResponse,
  unknown
>("adminGeneral/getAllGroupNotification", async (_, { rejectWithValue }) => {
  try {
    return await getAllGroupNotificationApi();
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getGroupNotification = createAsyncThunk<
  GroupNotificationResponse,
  { group_type: string }
>(
  "adminGeneral/getGroupNotification",
  async ({ group_type }, { rejectWithValue }) => {
    try {
      return await getGroupNotificationApi(group_type);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateGroupNotification = createAsyncThunk<
  string,
  { group_type: string; data: NotificationGroupRequest }
>(
  "adminGeneral/updateGroupNotification",
  async ({ group_type, data }, { rejectWithValue }) => {
    try {
      return await updateGroupNotificationApi(group_type, data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

type AdminGeneralState = State<{
  isNotificationsLoading: boolean;
  selectedGrouop: string | null;
  telegram_chat_id_super: string | null;
  telegram_chat_id_admin: string | null;
  telegram_chat_id_support: string | null;
}>;

const initialState: AdminGeneralState = {
  isNotificationsLoading: false,
  loading: false,
  error: null,
  selectedGrouop: null,
  telegram_chat_id_super: null,
  telegram_chat_id_admin: null,
  telegram_chat_id_support: null,
};

const adminGeneralStore = createSlice({
  name: "adminGeneral",
  initialState: initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isNotificationsLoading = action.payload;
    },
    setSelectedGroup: (state, action: PayloadAction<string>) => {
      state.selectedGrouop = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllGroupNotification.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllGroupNotification.fulfilled, (state, action) => {
        state.loading = false;
        action.payload.settings.forEach((data) => {
          switch (data.group_type) {
            case "administrator":
              state.telegram_chat_id_admin = data.telegram_chat_id;
              break;
            case "customer_support":
              state.telegram_chat_id_support = data.telegram_chat_id;
              break;
            case "super_user":
              state.telegram_chat_id_super = data.telegram_chat_id;
              break;
          }
        });
      })
      .addCase(getAllGroupNotification.rejected, (state, action) => {
        state.loading = true;
        state.error = action.payload as string;
      })
      .addCase(getGroupNotification.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGroupNotification.fulfilled, (state, action) => {
        state.loading = false;
        switch (state.selectedGrouop) {
          case "super_user":
            state.telegram_chat_id_super = action.payload.telegram_chat_id;
            break;
          case "administrator":
            state.telegram_chat_id_admin = action.payload.telegram_chat_id;
            break;
          case "customer_support":
            state.telegram_chat_id_support = action.payload.telegram_chat_id;
            break;
          default:
            return;
        }
        console.log(action.payload);
      })
      .addCase(getGroupNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateGroupNotification.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateGroupNotification.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
      })
      .addCase(updateGroupNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});
export const { setLoading, setSelectedGroup } = adminGeneralStore.actions;
export default adminGeneralStore.reducer;
